<template>
  <transition :appear="true"
              :name="name"
              :mode="mode"
              :appear-class="name + '-appear'"
              appear-active-class="transition-appear"
              enter-active-class="transition-enter"
              :leave-active-class="mode ? 'transition-enter' : ''">
    <div :key="hash || Math.random()">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    'value': {}, 'name': {}, 'mode': { default: 'out-in' }, hash: {}
  },
  data () {
    return {}
  }
}
</script>
